import { render, staticRenderFns } from "./ModalOwners.vue?vue&type=template&id=49f8e726&"
import script from "./ModalOwners.vue?vue&type=script&lang=js&"
export * from "./ModalOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports